// extracted by mini-css-extract-plugin
export default {"Container":"DefaultLayout_Container__W1Iy3","Container__content":"DefaultLayout_Container__content__b8X+M"};